// Product Categories and Their Specifications

export const PRODUCT_CATEGORIES = [
    // Electronics - Computers
    { value: 'laptops', label: '💻 Laptops', group: 'Electronics - Computers' },
    { value: 'desktop_computers', label: '🖥️ Desktop Computers', group: 'Electronics - Computers' },
    { value: 'tablets', label: '📱 Tablets', group: 'Electronics - Computers' },
    
    // Electronics - Mobile
    { value: 'smartphones', label: '📱 Smartphones / Mobile', group: 'Electronics - Mobile' },
    
    // Electronics - Display & Audio
    { value: 'projectors', label: '📽️ Projectors', group: 'Electronics - Display & Audio' },
    { value: 'led_smart_tvs', label: '📺 LED / Smart TVs', group: 'Electronics - Display & Audio' },
    { value: 'home_theatre', label: '🎭 Home Theatre Systems', group: 'Electronics - Display & Audio' },
    { value: 'sound_systems', label: '🔊 Sound Systems / Speakers', group: 'Electronics - Display & Audio' },
    
    // Electronics - Peripherals
    { value: 'printers', label: '🖨️ Printers', group: 'Electronics - Peripherals' },
    { value: 'scanners', label: '📠 Scanners', group: 'Electronics - Peripherals' },
    
    // Electronics - Security
    { value: 'cctv', label: '📹 CCTV Camera Systems', group: 'Electronics - Security' },
    { value: 'biometric', label: '👤 Biometric Attendance Machines', group: 'Electronics - Security' },
    { value: 'access_control', label: '🔐 Access Control Systems', group: 'Electronics - Security' },
    
    // Electronics - Gaming & Wearables
    { value: 'gaming_consoles', label: '🎮 Gaming Consoles', group: 'Electronics - Gaming & Wearables' },
    { value: 'smart_watches', label: '⌚ Smart Watches', group: 'Electronics - Gaming & Wearables' },
    
    // Home Appliances
    { value: 'air_conditioners', label: '❄️ Air Conditioners', group: 'Home Appliances' },
    { value: 'refrigerators', label: '🧊 Refrigerators', group: 'Home Appliances' },
    { value: 'washing_machines', label: '🧺 Washing Machines', group: 'Home Appliances' },
    { value: 'microwave_ovens', label: '🍲 Microwave Ovens', group: 'Home Appliances' },
    { value: 'water_purifiers', label: '💧 Water Purifiers', group: 'Home Appliances' },
    { value: 'water_dispensers', label: '🚰 Water Dispensers', group: 'Home Appliances' },
    { value: 'vacuum_cleaners', label: '🧹 Vacuum Cleaners', group: 'Home Appliances' },
    { value: 'fans', label: '💨 Fans', group: 'Home Appliances' },
    { value: 'heaters', label: '🔥 Heaters', group: 'Home Appliances' },
    { value: 'air_coolers', label: '❄️ Air Coolers', group: 'Home Appliances' },
    
    // Power & Energy
    { value: 'solar_panels', label: '☀️ Solar Panels / Solar Systems', group: 'Power & Energy' },
    { value: 'inverters', label: '🔌 Inverters', group: 'Power & Energy' },
    { value: 'batteries', label: '🔋 Batteries', group: 'Power & Energy' },
    { value: 'ups', label: '⚡ UPS', group: 'Power & Energy' },
    
    // Vehicles
    { value: 'cars', label: '🚗 Cars', group: 'Vehicles' },
    { value: 'bikes', label: '🏍️ Bikes', group: 'Vehicles' },
    { value: 'e_bikes', label: '🚲 E-Bikes', group: 'Vehicles' },
    { value: 'tyres', label: '🛞 Tyres', group: 'Vehicles' },
    
    // Furniture
    { value: 'office_furniture', label: '🏢 Office Furniture', group: 'Furniture' },
    { value: 'home_furniture', label: '🛋️ Home Furniture', group: 'Furniture' },
    { value: 'mattress', label: '🛏️ Mattress', group: 'Furniture' },
];

export const CATEGORY_SPECIFICATIONS = {
    laptops: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Processor', type: 'text', required: true },
        { field: 'Generation', type: 'text' },
        { field: 'RAM', type: 'text', required: true },
        { field: 'Storage Type', type: 'select', options: ['HDD', 'SSD', 'Hybrid', 'eMMC'] },
        { field: 'Storage Capacity', type: 'text', required: true },
        { field: 'Screen Size', type: 'text' },
        { field: 'Resolution', type: 'text' },
        { field: 'Graphics', type: 'text' },
        { field: 'Operating System', type: 'select', options: ['Windows 11', 'Windows 10', 'macOS', 'Linux', 'Chrome OS', 'DOS'] },
        { field: 'Battery Backup', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Color', type: 'text' },
        { field: 'Ports', type: 'textarea' },
        { field: 'Connectivity', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    desktop_computers: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Processor', type: 'text', required: true },
        { field: 'RAM', type: 'text', required: true },
        { field: 'Storage Type', type: 'select', options: ['HDD', 'SSD', 'Hybrid'] },
        { field: 'Storage Capacity', type: 'text', required: true },
        { field: 'Graphics', type: 'text' },
        { field: 'Operating System', type: 'select', options: ['Windows 11', 'Windows 10', 'Linux', 'DOS'] },
        { field: 'Cabinet Type', type: 'select', options: ['Tower', 'Mini Tower', 'Desktop', 'All-in-One'] },
        { field: 'Monitor Included', type: 'select', options: ['Yes', 'No'] },
        { field: 'Monitor Size', type: 'text' },
        { field: 'Keyboard', type: 'select', options: ['Included', 'Not Included', 'Wireless', 'Wired'] },
        { field: 'Mouse', type: 'select', options: ['Included', 'Not Included', 'Wireless', 'Wired'] },
        { field: 'Ports', type: 'textarea' },
        { field: 'Connectivity', type: 'text' },
        { field: 'Power Supply', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    smartphones: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Processor', type: 'text' },
        { field: 'RAM', type: 'text', required: true },
        { field: 'Internal Storage', type: 'text', required: true },
        { field: 'Expandable Storage', type: 'select', options: ['Yes', 'No'] },
        { field: 'Screen Size', type: 'text' },
        { field: 'Resolution', type: 'text' },
        { field: 'Display Type', type: 'text' },
        { field: 'Front Camera', type: 'text' },
        { field: 'Back Camera', type: 'text' },
        { field: 'Battery Capacity', type: 'text' },
        { field: 'Operating System', type: 'text' },
        { field: 'SIM Support', type: 'select', options: ['Single SIM', 'Dual SIM', 'eSIM'] },
        { field: '5G Support', type: 'select', options: ['Yes', 'No'] },
        { field: 'Fast Charging', type: 'select', options: ['Yes', 'No'] },
        { field: 'Color', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    tablets: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Screen Size', type: 'text', required: true },
        { field: 'Resolution', type: 'text' },
        { field: 'Processor', type: 'text' },
        { field: 'RAM', type: 'text', required: true },
        { field: 'Storage', type: 'text', required: true },
        { field: 'Expandable Storage', type: 'select', options: ['Yes', 'No'] },
        { field: 'OS', type: 'select', options: ['Android', 'iOS', 'Windows', 'Other'] },
        { field: 'Camera', type: 'text' },
        { field: 'Battery', type: 'text' },
        { field: 'Connectivity', type: 'text' },
        { field: 'SIM Support', type: 'select', options: ['WiFi Only', 'WiFi + Cellular', 'eSIM'] },
        { field: 'Weight', type: 'text' },
        { field: 'Color', type: 'text' },
        { field: 'Accessories', type: 'textarea' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    projectors: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Projection Type', type: 'select', options: ['LCD', 'DLP', 'LED', 'Laser'] },
        { field: 'Resolution', type: 'select', options: ['HD (720p)', 'Full HD (1080p)', '4K UHD', 'WXGA', 'XGA'] },
        { field: 'Brightness', type: 'text', placeholder: 'Lumens' },
        { field: 'Contrast Ratio', type: 'text' },
        { field: 'Aspect Ratio', type: 'select', options: ['16:9', '16:10', '4:3'] },
        { field: 'Throw Distance', type: 'text' },
        { field: 'Screen Size', type: 'text', placeholder: 'Min-Max inches' },
        { field: 'Lamp Life', type: 'text', placeholder: 'Hours' },
        { field: 'Connectivity', type: 'textarea', placeholder: 'HDMI, USB, VGA, etc.' },
        { field: 'Speaker', type: 'text' },
        { field: 'Noise Level', type: 'text' },
        { field: 'Power Consumption', type: 'text' },
        { field: 'Mount Type', type: 'select', options: ['Ceiling', 'Table', 'Portable', 'Wall'] },
        { field: 'Weight', type: 'text' },
        { field: 'Color', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    printers: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Printer Type', type: 'select', options: ['Single Function', 'Multi Function', 'All-in-One'] },
        { field: 'Print Technology', type: 'select', options: ['Inkjet', 'Laser', 'Thermal', 'Dot Matrix'] },
        { field: 'Print Speed', type: 'text', placeholder: 'ppm' },
        { field: 'Resolution', type: 'text', placeholder: 'dpi' },
        { field: 'Paper Size', type: 'text', placeholder: 'A4, A3, etc.' },
        { field: 'Duplex Printing', type: 'select', options: ['Yes', 'No', 'Manual'] },
        { field: 'Connectivity', type: 'text', placeholder: 'USB, WiFi, Ethernet' },
        { field: 'Ink / Toner Type', type: 'text' },
        { field: 'Cartridge Yield', type: 'text', placeholder: 'Pages' },
        { field: 'Display', type: 'text' },
        { field: 'Power Consumption', type: 'text' },
        { field: 'Duty Cycle', type: 'text', placeholder: 'Pages/Month' },
        { field: 'OS Support', type: 'text' },
        { field: 'Dimensions', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
        { field: 'Usage Type', type: 'select', options: ['Home', 'Office', 'Commercial'] },
        { field: 'Color / Mono', type: 'select', options: ['Color', 'Monochrome', 'Both'] },
    ],
    
    scanners: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Scanner Type', type: 'select', options: ['Flatbed', 'Sheet-fed', 'Portable', 'Document Scanner'] },
        { field: 'Scan Resolution', type: 'text', placeholder: 'dpi' },
        { field: 'Scan Speed', type: 'text', placeholder: 'ppm' },
        { field: 'Paper Size', type: 'text' },
        { field: 'ADF', type: 'select', options: ['Yes', 'No'] },
        { field: 'Connectivity', type: 'text' },
        { field: 'File Formats', type: 'text', placeholder: 'PDF, JPEG, etc.' },
        { field: 'OCR Support', type: 'select', options: ['Yes', 'No'] },
        { field: 'Color Depth', type: 'text', placeholder: 'bit' },
        { field: 'Power Consumption', type: 'text' },
        { field: 'Dimensions', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'OS Support', type: 'text' },
        { field: 'Accessories', type: 'textarea' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    cctv: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Camera Type', type: 'select', options: ['Dome', 'Bullet', 'PTZ', 'IP Camera', 'Wireless'] },
        { field: 'Resolution', type: 'select', options: ['720p', '1080p', '2MP', '4MP', '5MP', '4K'] },
        { field: 'Lens', type: 'text', placeholder: 'mm' },
        { field: 'Night Vision', type: 'select', options: ['Yes', 'No'] },
        { field: 'IR Distance', type: 'text', placeholder: 'meters' },
        { field: 'Storage Type', type: 'select', options: ['DVR', 'NVR', 'Cloud', 'SD Card'] },
        { field: 'Compression', type: 'select', options: ['H.264', 'H.265', 'MJPEG'] },
        { field: 'Connectivity', type: 'text' },
        { field: 'Weatherproof', type: 'select', options: ['Yes (Indoor/Outdoor)', 'Indoor Only'] },
        { field: 'Power Supply', type: 'text' },
        { field: 'Audio', type: 'select', options: ['Yes', 'No'] },
        { field: 'Viewing Angle', type: 'text', placeholder: 'degrees' },
        { field: 'Installation Type', type: 'select', options: ['Wired', 'Wireless', 'PoE'] },
        { field: 'Operating Temperature', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
        { field: 'Usage Area', type: 'select', options: ['Home', 'Office', 'Industrial', 'Outdoor'] },
        { field: 'Smart Features', type: 'textarea' },
    ],
    
    biometric: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Authentication Type', type: 'select', options: ['Fingerprint', 'Face Recognition', 'Iris', 'Palm', 'Multi-Modal'] },
        { field: 'Capacity', type: 'text', placeholder: 'Users' },
        { field: 'Log Storage', type: 'text', placeholder: 'Records' },
        { field: 'Display', type: 'text' },
        { field: 'Connectivity', type: 'text', placeholder: 'WiFi, USB, RS232' },
        { field: 'Communication', type: 'select', options: ['TCP/IP', 'WiFi', 'USB', 'RS485'] },
        { field: 'Power Supply', type: 'text' },
        { field: 'Backup Battery', type: 'select', options: ['Yes', 'No'] },
        { field: 'Integration Support', type: 'text' },
        { field: 'Operating System', type: 'text' },
        { field: 'Installation Type', type: 'select', options: ['Wall Mount', 'Desktop', 'Standalone'] },
        { field: 'Operating Temperature', type: 'text' },
        { field: 'Material', type: 'text' },
        { field: 'Dimensions', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    access_control: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Access Type', type: 'select', options: ['Card Reader', 'Biometric', 'PIN', 'Multi-Factor'] },
        { field: 'Authentication Method', type: 'select', options: ['RFID', 'Fingerprint', 'Face Recognition', 'PIN Code', 'Combination'] },
        { field: 'User Capacity', type: 'text' },
        { field: 'Event Log', type: 'text', placeholder: 'Records' },
        { field: 'Reader Type', type: 'text' },
        { field: 'Connectivity', type: 'text' },
        { field: 'Communication Protocol', type: 'text' },
        { field: 'Power Supply', type: 'text' },
        { field: 'Backup Battery', type: 'select', options: ['Yes', 'No'] },
        { field: 'Door Type', type: 'select', options: ['Single Door', 'Double Door', 'Multiple Doors'] },
        { field: 'Integration Support', type: 'textarea' },
        { field: 'Installation Type', type: 'select', options: ['Surface Mount', 'Flush Mount', 'Standalone'] },
        { field: 'Material', type: 'text' },
        { field: 'Dimensions', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    gaming_consoles: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Console Type', type: 'select', options: ['Home Console', 'Portable', 'Hybrid'] },
        { field: 'Storage', type: 'text', required: true },
        { field: 'RAM', type: 'text' },
        { field: 'Processor', type: 'text' },
        { field: 'Graphics', type: 'text' },
        { field: 'Resolution Support', type: 'select', options: ['720p', '1080p', '4K', '8K'] },
        { field: 'FPS Support', type: 'text' },
        { field: 'Connectivity', type: 'text' },
        { field: 'Controller Included', type: 'select', options: ['Yes', 'No'] },
        { field: 'Number of Controllers', type: 'text' },
        { field: 'Online Support', type: 'select', options: ['Yes', 'No'] },
        { field: 'Backward Compatibility', type: 'text' },
        { field: 'Power Consumption', type: 'text' },
        { field: 'Warranty', type: 'text' },
    ],
    
    led_smart_tvs: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Screen Size', type: 'text', required: true, placeholder: 'inches' },
        { field: 'Resolution', type: 'select', options: ['HD Ready (720p)', 'Full HD (1080p)', '4K UHD', '8K'] },
        { field: 'Display Type', type: 'select', options: ['LED', 'QLED', 'OLED', 'Mini LED'] },
        { field: 'Refresh Rate', type: 'select', options: ['60Hz', '120Hz', '144Hz'] },
        { field: 'Smart TV', type: 'select', options: ['Yes', 'No'] },
        { field: 'Operating System', type: 'select', options: ['Android TV', 'WebOS', 'Tizen', 'Fire TV', 'Roku', 'Other'] },
        { field: 'HDR Support', type: 'text', placeholder: 'HDR10, Dolby Vision, etc.' },
        { field: 'Connectivity', type: 'textarea', placeholder: 'WiFi, Bluetooth, etc.' },
        { field: 'Ports', type: 'textarea', placeholder: 'HDMI, USB, etc.' },
        { field: 'Audio Output', type: 'text', placeholder: 'Watts' },
        { field: 'Speaker Type', type: 'text' },
        { field: 'Wall Mount', type: 'select', options: ['Included', 'Not Included', 'Compatible'] },
        { field: 'Power Consumption', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    home_theatre: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Channel Configuration', type: 'select', options: ['2.1', '5.1', '7.1', '9.1', 'Soundbar'] },
        { field: 'Output Power', type: 'text', placeholder: 'Watts' },
        { field: 'Speaker Type', type: 'text' },
        { field: 'Connectivity', type: 'textarea' },
        { field: 'Bluetooth', type: 'select', options: ['Yes', 'No'] },
        { field: 'USB Support', type: 'select', options: ['Yes', 'No'] },
        { field: 'HDMI', type: 'text', placeholder: 'Number of ports' },
        { field: 'Audio Formats', type: 'text' },
        { field: 'Remote Control', type: 'select', options: ['Yes', 'No'] },
        { field: 'Display', type: 'text' },
        { field: 'Mount Type', type: 'text' },
        { field: 'Power Consumption', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Color', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    sound_systems: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Speaker Type', type: 'select', options: ['Portable', 'Bookshelf', 'Tower', 'Soundbar', 'Subwoofer'] },
        { field: 'Output Power', type: 'text', placeholder: 'Watts' },
        { field: 'Frequency Response', type: 'text', placeholder: 'Hz' },
        { field: 'Impedance', type: 'text', placeholder: 'Ohms' },
        { field: 'Connectivity', type: 'textarea' },
        { field: 'Bluetooth', type: 'select', options: ['Yes', 'No'] },
        { field: 'USB Support', type: 'select', options: ['Yes', 'No'] },
        { field: 'AUX', type: 'select', options: ['Yes', 'No'] },
        { field: 'Remote', type: 'select', options: ['Yes', 'No'] },
        { field: 'Battery', type: 'text' },
        { field: 'Power Consumption', type: 'text' },
        { field: 'Dimensions', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Color', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    smart_watches: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Display Type', type: 'select', options: ['AMOLED', 'LCD', 'OLED', 'E-Ink'] },
        { field: 'Screen Size', type: 'text', placeholder: 'inches' },
        { field: 'Resolution', type: 'text' },
        { field: 'Operating System', type: 'select', options: ['Wear OS', 'watchOS', 'Tizen', 'Proprietary'] },
        { field: 'Compatibility', type: 'text', placeholder: 'Android, iOS' },
        { field: 'Sensors', type: 'textarea', placeholder: 'Heart Rate, GPS, etc.' },
        { field: 'Fitness Tracking', type: 'textarea' },
        { field: 'Battery Life', type: 'text', placeholder: 'Days' },
        { field: 'Charging Type', type: 'text' },
        { field: 'Connectivity', type: 'text' },
        { field: 'Water Resistance', type: 'text', placeholder: 'IP Rating or ATM' },
        { field: 'Strap Material', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Color', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    // Home Appliances
    air_conditioners: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Type', type: 'select', options: ['Split', 'Window', 'Portable', 'Cassette', 'Floor Standing'] },
        { field: 'Capacity', type: 'select', options: ['0.5 Ton', '0.75 Ton', '1 Ton', '1.5 Ton', '2 Ton', '2.5 Ton', '3 Ton'] },
        { field: 'Energy Rating', type: 'select', options: ['1 Star', '2 Star', '3 Star', '4 Star', '5 Star', 'Inverter'] },
        { field: 'Cooling Capacity', type: 'text', placeholder: 'BTU' },
        { field: 'Technology', type: 'select', options: ['Inverter', 'Non-Inverter'] },
        { field: 'Refrigerant', type: 'text', placeholder: 'R-32, R-410A' },
        { field: 'Power Consumption', type: 'text', placeholder: 'Watts' },
        { field: 'Noise Level', type: 'text', placeholder: 'dB' },
        { field: 'Operating Temperature Range', type: 'text' },
        { field: 'Smart Features', type: 'textarea' },
        { field: 'Filter Type', type: 'text' },
        { field: 'Color', type: 'text' },
        { field: 'Dimensions (Indoor)', type: 'text' },
        { field: 'Dimensions (Outdoor)', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Installation', type: 'select', options: ['Included', 'Not Included'] },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    refrigerators: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Type', type: 'select', options: ['Single Door', 'Double Door', 'Side-by-Side', 'French Door', 'Mini'] },
        { field: 'Capacity', type: 'text', placeholder: 'Liters', required: true },
        { field: 'Energy Rating', type: 'select', options: ['1 Star', '2 Star', '3 Star', '4 Star', '5 Star'] },
        { field: 'Defrosting Type', type: 'select', options: ['Manual', 'Direct Cool', 'Frost Free'] },
        { field: 'Compressor Type', type: 'select', options: ['Regular', 'Inverter', 'Digital Inverter'] },
        { field: 'Shelves', type: 'text' },
        { field: 'Smart Features', type: 'textarea' },
        { field: 'Color', type: 'text' },
        { field: 'Dimensions', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    washing_machines: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Type', type: 'select', options: ['Fully Automatic', 'Semi Automatic', 'Top Load', 'Front Load'], required: true },
        { field: 'Capacity', type: 'text', placeholder: 'kg', required: true },
        { field: 'Energy Rating', type: 'select', options: ['1 Star', '2 Star', '3 Star', '4 Star', '5 Star'] },
        { field: 'Spin Speed', type: 'text', placeholder: 'RPM' },
        { field: 'Wash Programs', type: 'text' },
        { field: 'Smart Features', type: 'textarea' },
        { field: 'Color', type: 'text' },
        { field: 'Dimensions', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    microwave_ovens: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Type', type: 'select', options: ['Solo', 'Grill', 'Convection'] },
        { field: 'Capacity', type: 'text', placeholder: 'Liters', required: true },
        { field: 'Power Output', type: 'text', placeholder: 'Watts' },
        { field: 'Control Type', type: 'select', options: ['Mechanical', 'Digital', 'Touch'] },
        { field: 'Cooking Modes', type: 'text' },
        { field: 'Color', type: 'text' },
        { field: 'Dimensions', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    water_purifiers: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Purification Type', type: 'select', options: ['RO', 'UV', 'UF', 'RO+UV', 'RO+UV+UF'] },
        { field: 'Storage Capacity', type: 'text', placeholder: 'Liters' },
        { field: 'Purification Capacity', type: 'text', placeholder: 'Liters/hour' },
        { field: 'Installation Type', type: 'select', options: ['Wall Mounted', 'Table Top'] },
        { field: 'Filter Stages', type: 'text' },
        { field: 'Smart Features', type: 'textarea' },
        { field: 'Dimensions', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    water_dispensers: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Type', type: 'select', options: ['Top Loading', 'Bottom Loading', 'Direct Pipe'] },
        { field: 'Hot Water', type: 'select', options: ['Yes', 'No'] },
        { field: 'Cold Water', type: 'select', options: ['Yes', 'No'] },
        { field: 'Room Temperature', type: 'select', options: ['Yes', 'No'] },
        { field: 'Cooling Type', type: 'select', options: ['Compressor', 'Electronic'] },
        { field: 'Storage Capacity', type: 'text', placeholder: 'Liters' },
        { field: 'Power Consumption', type: 'text' },
        { field: 'Material', type: 'text' },
        { field: 'Dimensions', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    vacuum_cleaners: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Type', type: 'select', options: ['Upright', 'Canister', 'Handheld', 'Robot', 'Wet & Dry'] },
        { field: 'Power', type: 'text', placeholder: 'Watts' },
        { field: 'Suction Power', type: 'text', placeholder: 'Pa' },
        { field: 'Dust Capacity', type: 'text', placeholder: 'Liters' },
        { field: 'Filtration', type: 'text', placeholder: 'HEPA, etc.' },
        { field: 'Cord Length', type: 'text', placeholder: 'meters' },
        { field: 'Cordless', type: 'select', options: ['Yes', 'No'] },
        { field: 'Battery Life', type: 'text', placeholder: 'minutes' },
        { field: 'Accessories', type: 'textarea' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    fans: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Type', type: 'select', options: ['Ceiling', 'Pedestal', 'Wall Mount', 'Table', 'Exhaust'] },
        { field: 'Blade Size', type: 'text', placeholder: 'inches' },
        { field: 'Speed Settings', type: 'text' },
        { field: 'Power Consumption', type: 'text', placeholder: 'Watts' },
        { field: 'Air Delivery', type: 'text', placeholder: 'CMM' },
        { field: 'Remote Control', type: 'select', options: ['Yes', 'No'] },
        { field: 'Color', type: 'text' },
        { field: 'Material', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    heaters: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Type', type: 'select', options: ['Room Heater', 'Water Heater', 'Oil Filled', 'Halogen', 'Fan Heater'] },
        { field: 'Power', type: 'text', placeholder: 'Watts', required: true },
        { field: 'Heating Capacity', type: 'text', placeholder: 'sq ft' },
        { field: 'Temperature Control', type: 'select', options: ['Yes', 'No'] },
        { field: 'Timer', type: 'select', options: ['Yes', 'No'] },
        { field: 'Safety Features', type: 'textarea' },
        { field: 'Dimensions', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    air_coolers: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Type', type: 'select', options: ['Desert', 'Personal', 'Tower', 'Window'] },
        { field: 'Cooling Area', type: 'text', placeholder: 'sq ft' },
        { field: 'Water Tank Capacity', type: 'text', placeholder: 'Liters' },
        { field: 'Air Throw', type: 'text', placeholder: 'feet' },
        { field: 'Power Consumption', type: 'text', placeholder: 'Watts' },
        { field: 'Speed Settings', type: 'text' },
        { field: 'Remote Control', type: 'select', options: ['Yes', 'No'] },
        { field: 'Castor Wheels', type: 'select', options: ['Yes', 'No'] },
        { field: 'Dimensions', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    // Power & Energy
    solar_panels: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Type', type: 'select', options: ['Monocrystalline', 'Polycrystalline', 'Thin Film', 'PERC'] },
        { field: 'Capacity', type: 'text', placeholder: 'Watts', required: true },
        { field: 'Efficiency', type: 'text', placeholder: '%' },
        { field: 'Voltage', type: 'text', placeholder: 'V' },
        { field: 'Current', type: 'text', placeholder: 'A' },
        { field: 'Dimensions', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Frame Material', type: 'text' },
        { field: 'Temperature Coefficient', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    inverters: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Type', type: 'select', options: ['Pure Sine Wave', 'Modified Sine Wave', 'Solar Inverter', 'Hybrid'] },
        { field: 'Capacity', type: 'text', placeholder: 'VA/Watts', required: true },
        { field: 'Input Voltage', type: 'text', placeholder: 'V' },
        { field: 'Output Voltage', type: 'text', placeholder: 'V' },
        { field: 'Battery Type', type: 'select', options: ['Tubular', 'Flat Plate', 'Lithium-ion'] },
        { field: 'Charging Current', type: 'text', placeholder: 'A' },
        { field: 'Backup Time', type: 'text', placeholder: 'hours' },
        { field: 'Display Type', type: 'select', options: ['LCD', 'LED', 'Digital', 'None'] },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    batteries: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Type', type: 'select', options: ['Tubular', 'Flat Plate', 'Lithium-ion', 'SMF', 'Lead Acid'], required: true },
        { field: 'Capacity', type: 'text', placeholder: 'Ah', required: true },
        { field: 'Voltage', type: 'text', placeholder: 'V' },
        { field: 'Warranty', type: 'text' },
        { field: 'Weight', type: 'text' },
        { field: 'Dimensions', type: 'text' },
        { field: 'Usage', type: 'select', options: ['Inverter', 'Solar', 'UPS', 'Automotive'] },
        { field: 'Maintenance', type: 'select', options: ['Maintenance Free', 'Low Maintenance', 'Regular Maintenance'] },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    ups: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Type', type: 'select', options: ['Online', 'Offline', 'Line Interactive'] },
        { field: 'Capacity', type: 'text', placeholder: 'VA/Watts', required: true },
        { field: 'Input Voltage', type: 'text', placeholder: 'V' },
        { field: 'Output Voltage', type: 'text', placeholder: 'V' },
        { field: 'Backup Time', type: 'text', placeholder: 'minutes' },
        { field: 'Battery Type', type: 'text' },
        { field: 'Number of Outlets', type: 'text' },
        { field: 'Display', type: 'select', options: ['LCD', 'LED', 'None'] },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    // Vehicles
    cars: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Year', type: 'text', placeholder: '2024', required: true },
        { field: 'Engine Type', type: 'select', options: ['Petrol', 'Diesel', 'CNG', 'LPG', 'Hybrid', 'Electric'] },
        { field: 'Engine Capacity', type: 'text', placeholder: 'cc' },
        { field: 'Transmission', type: 'select', options: ['Manual', 'Automatic', 'CVT', 'DSG'] },
        { field: 'Mileage', type: 'text', placeholder: 'km/l' },
        { field: 'Fuel Tank Capacity', type: 'text', placeholder: 'Liters' },
        { field: 'Seating Capacity', type: 'text' },
        { field: 'Color', type: 'text' },
        { field: 'Features', type: 'textarea', placeholder: 'AC, Power Windows, ABS, Airbags, etc.' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    bikes: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Year', type: 'text', placeholder: '2024' },
        { field: 'Engine Capacity', type: 'text', placeholder: 'cc', required: true },
        { field: 'Type', type: 'select', options: ['Sport', 'Cruiser', 'Standard', 'Adventure', 'Scooter'] },
        { field: 'Fuel Type', type: 'select', options: ['Petrol', 'CNG', 'Hybrid'] },
        { field: 'Mileage', type: 'text', placeholder: 'km/l' },
        { field: 'Transmission', type: 'select', options: ['Manual', 'Automatic', 'CVT'] },
        { field: 'Starting', type: 'select', options: ['Self Start', 'Kick Start', 'Both'] },
        { field: 'Fuel Tank Capacity', type: 'text', placeholder: 'Liters' },
        { field: 'Weight', type: 'text', placeholder: 'kg' },
        { field: 'Color', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    e_bikes: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Motor Power', type: 'text', placeholder: 'Watts', required: true },
        { field: 'Battery Capacity', type: 'text', placeholder: 'Ah', required: true },
        { field: 'Battery Type', type: 'select', options: ['Lithium-ion', 'Lead Acid', 'Lithium Polymer'] },
        { field: 'Range', type: 'text', placeholder: 'km' },
        { field: 'Charging Time', type: 'text', placeholder: 'hours' },
        { field: 'Top Speed', type: 'text', placeholder: 'km/h' },
        { field: 'Weight', type: 'text', placeholder: 'kg' },
        { field: 'Load Capacity', type: 'text', placeholder: 'kg' },
        { field: 'Brakes', type: 'text', placeholder: 'Disc, Drum, etc.' },
        { field: 'Tyre Type', type: 'text' },
        { field: 'Frame Material', type: 'text' },
        { field: 'Color', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    tyres: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Size', type: 'text', placeholder: 'e.g., 195/65 R15', required: true },
        { field: 'Type', type: 'select', options: ['Tubeless', 'Tube Type'] },
        { field: 'Vehicle Type', type: 'select', options: ['Car', 'SUV', 'Bike', 'Truck', 'Bus'] },
        { field: 'Season', type: 'select', options: ['All Season', 'Summer', 'Winter'] },
        { field: 'Speed Rating', type: 'text' },
        { field: 'Load Index', type: 'text' },
        { field: 'Tread Pattern', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    // Furniture
    office_furniture: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Item Type', type: 'select', options: ['Office Chair', 'Office Table', 'Desk', 'Cabinet', 'Bookshelf', 'Conference Table', 'Workstation'], required: true },
        { field: 'Material', type: 'text', placeholder: 'Wood, Metal, Plastic, etc.' },
        { field: 'Color', type: 'text' },
        { field: 'Dimensions', type: 'text', placeholder: 'L x W x H' },
        { field: 'Weight Capacity', type: 'text', placeholder: 'kg' },
        { field: 'Assembly Required', type: 'select', options: ['Yes', 'No'] },
        { field: 'Adjustable', type: 'select', options: ['Yes', 'No'] },
        { field: 'Features', type: 'textarea' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    home_furniture: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Item Type', type: 'select', options: ['Sofa', 'Bed', 'Dining Table', 'Chair', 'Wardrobe', 'Dressing Table', 'TV Unit', 'Side Table'], required: true },
        { field: 'Material', type: 'text', placeholder: 'Wood, Fabric, Leather, etc.' },
        { field: 'Color', type: 'text' },
        { field: 'Dimensions', type: 'text', placeholder: 'L x W x H' },
        { field: 'Seating Capacity', type: 'text', placeholder: 'For sofas/dining tables' },
        { field: 'Storage', type: 'select', options: ['Yes', 'No'] },
        { field: 'Assembly Required', type: 'select', options: ['Yes', 'No'] },
        { field: 'Features', type: 'textarea' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
    
    mattress: [
        { field: 'Brand', type: 'text', required: true },
        { field: 'Model', type: 'text', required: true },
        { field: 'Size', type: 'select', options: ['Single', 'Double', 'Queen', 'King', 'Super King'], required: true },
        { field: 'Type', type: 'select', options: ['Spring', 'Memory Foam', 'Latex', 'Orthopedic', 'Hybrid'] },
        { field: 'Thickness', type: 'text', placeholder: 'inches' },
        { field: 'Firmness', type: 'select', options: ['Soft', 'Medium', 'Firm', 'Extra Firm'] },
        { field: 'Cover Material', type: 'text' },
        { field: 'Dimensions', type: 'text', placeholder: 'L x W x H' },
        { field: 'Weight', type: 'text' },
        { field: 'Warranty', type: 'text' },
        { field: 'Country of Origin', type: 'text' },
    ],
};

// Helper function to get grouped categories
export const getGroupedCategories = () => {
    const grouped = {};
    PRODUCT_CATEGORIES.forEach(cat => {
        if (!grouped[cat.group]) {
            grouped[cat.group] = [];
        }
        grouped[cat.group].push(cat);
    });
    return grouped;
};
